export enum TransactionState {
  WAITING_FOR_CONFIRMATION = 'WAITING_FOR_CONFIRMATION',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR'
}
